/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".ms-BasicButtonsExample .ms-Button{margin:10px 0}\n"}]);